const LocationActionTypes = {
	FETCH_LOCATION_REQUEST: "FETCH_LOCATION_REQUEST",
	FETCH_LOCATION_RECEIVE: "FETCH_LOCATION_RECEIVE",
	FETCH_LOCATION_FAILURE: "FETCH_LOCATION_FAILURE"
};

export default LocationActionTypes;
